import { Map, Marker, InfoWindow, GoogleApiWrapper } from "google-maps-react";
import { Typography } from "@material-ui/core";
import React, { Component } from "react";
import Geocode from "react-geocode";
const containerStyle = {
    position: "relative",
    width: "calc(100% + 47px)",
    height: "calc(100% - 85px)",
    minHeight: 300
};

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            lng: 0,
            markerName: "",
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            coords: false,
            routes: false,
            selectedCoord: false,
            details: false
        };
        Geocode.setApiKey(props.MapKey);
    }
  
    onMarkerChange = () => {
        const { coords } = this.state;

        Geocode.fromLatLng(coords).then(
            response => {
                const address = response.results[0].formatted_address;
                this.setState({ markerName: address });
            },
            error => {}
        );
    };
    onMarkerClick = (props, marker, e, item) => {
        this.onMarkerChange();
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };

    onMapClicked = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };
    apiIsLoaded = () => {
        if (this.props.waypoints) {
            let ways =
                this.props.waypoints.map(e => {
                    return {
                        location: { lat: e.latitude, lng: e.longitude },
                        stopover: false
                    };
                }) || [];
            const directionsService = new this.props.google.maps.DirectionsService();
            const directionsDisplay = new this.props.google.maps.DirectionsRenderer();
            directionsService.route(
                {
                    origin: {
                        lat: this.props.start.latitude,
                        lng: this.props.start.longitude
                    },
                    waypoints: ways,
                    destination: {
                        lat: this.props.end.latitude,
                        lng: this.props.end.longitude
                    },
                    travelMode: "DRIVING"
                },
                (response, status) => {
                    if (status === "OK") {
                        directionsDisplay.setDirections(response);
                        let routes = response.routes[0].overview_path.map(e => {
                            return {
                                lat: e.lat(),
                                lng: e.lng()
                            };
                        });
                        this.setState({ routes });
                    } else {
                        window.alert(
                            "Directions request failed due to " + status
                        );
                    }
                }
            );
        }
    };
    render() {
        const { start, style, zoom } = this.props;
        const { details } = this.state;
        return (
            <Map
                id="map"
                style={style}
                google={this.props.google}
                initialCenter={{
                    lat: start.latitude,
                    lng: start.longitude
                }}
                zoom={zoom ? zoom : 16}
                center={
                    this.state.selectedCoord
                        ? this.state.selectedCoord
                        : {
                              lat: 53.3020686,
                              lng: -7.4909908
                          }
                }
                containerStyle={containerStyle}
                onClick={this.onMapClicked}
                onReady={() => this.apiIsLoaded()}
            >
                {this.props.notes &&
                    this.props.notes.map((f, i) => {
                        return (
                            <Marker
                                key={i}
                                position={{
                                    lat: f.location_lat,
                                    lng: f.location_long
                                }}
                                color
                                label= {f.ref}
                                name={"Attached Note"}
                                onClick={(props, marker, e) => {
                                    this.setState({
                                        selectedCoord: {
                                            lat: f.location_lat,
                                            lng: f.location_long
                                        },
                                        details: f,
                                        selectedPlace: props,
                                        activeMarker: marker,
                                        showingInfoWindow: true
                                    });
                                }}
                                icon={{
                                    url:
                                        f.ref_rating === "I"
                                            ? require("./imgs/way.png")
                                            : f.ref_rating === "U"
                                            ? require("./imgs/end.png")
                                            : require("./imgs/start.png"),
                                            anchor: new window.google.maps.Point(
                                                32,
                                                32
                                            ),
                                            scaledSize: new window.google.maps.Size(
                                                64,
                                                64
                                            )
                                }}
                            />
                        );
                    })}

                <InfoWindow
                    pixelOffset={"0"}
                    marker={this.state.activeMarker}
                    visible={this.state.showingInfoWindow}
                >
                    <div>
                        {details.photo_url && (
                            <img
                                src={details.photo_url}
                                alt={details.ref}
                                style={{ width: "100px", height: "auto" }}
                            />
                        )}
                        <Typography variant="subtitle">
                            <b>Ref: </b> {details ? details.ref : "N/A"}
                        </Typography>
                        <Typography variant="subtitle">
                            <b>Ref Rating: </b>{" "}
                            {details ? details.ref_rating : "N/A"}
                        </Typography>
                        <Typography variant="subtitle">
                            <b>Address: </b> {details ? details.address : "N/A"}
                        </Typography>
                        <Typography variant="subtitle">
                            <b>Comment: </b> {details ? details.comment : "N/A"}
                        </Typography>
                        <Typography variant="subtitle">
                            <b>Time In: </b>{" "}
                            {details ? details.time_recorded_in : "N/A"}
                        </Typography>
                        <Typography variant="subtitle">
                            <b>Time Out: </b>{" "}
                            {details ? details.time_recorded_out : "N/A"}
                        </Typography>
                    </div>
                </InfoWindow>
            </Map>
        );
    }
}

export default GoogleApiWrapper(props => ({
    apiKey: props.mapKey
}))(MapContainer);
